import { NAV_LINKS, SITE } from "../data/site";

export const Footer = () => (
    <footer className="bg-sand/70 pb-28 md:pb-10 pt-12" data-testid="site-footer">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
                <div className="max-w-sm">
                    <a href="#acasa" className="flex items-center gap-2.5" data-testid="footer-logo">
                        <img src="/logo.png" alt="Sigla Ține(te) de noi" className="h-10 w-10 rounded-full object-cover ring-1 ring-teal/10" />
                        <span className="font-serif text-xl font-semibold text-teal">
                            Ține<span className="text-coral">(te)</span> de noi
                        </span>
                    </a>
                    <p className="mt-4 text-sm text-charcoal/65 leading-relaxed">
                        {SITE.tagline}. Nu oferim servicii medicale — îngrijirea reglementată este prestată de furnizori acreditați și licențiați.
                    </p>
                </div>
                <nav className="grid grid-cols-2 gap-x-10 gap-y-3" aria-label="Navigație subsol">
                    {NAV_LINKS.map((l) => (
                        <a key={l.href} href={l.href} data-testid={`footer-link-${l.href.slice(1)}`} className="text-sm font-medium text-charcoal/70 link-underline w-fit">
                            {l.label}
                        </a>
                    ))}
                    <a href={SITE.phoneHref} data-testid="footer-phone" className="text-sm font-semibold text-teal link-underline w-fit">
                        {SITE.phoneDisplay}
                    </a>
                    <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="text-sm font-semibold text-teal link-underline w-fit">
                        {SITE.email}
                    </a>
                </nav>
            </div>
            <div className="mt-10 border-t border-teal/10 pt-6 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
                <p className="text-xs text-charcoal/50">© 2026 Ține(te) de noi · {SITE.domain}</p>
                <button
                    type="button"
                    data-testid="footer-cookie-settings"
                    onClick={() => window.Cookiebot && window.Cookiebot.renew()}
                    className="text-xs font-medium text-charcoal/60 link-underline w-fit text-left"
                >
                    Modifică preferințele cookie
                </button>
                <p className="text-xs text-charcoal/50">Ține-te de noi, ca să-ți vezi de viața ta.</p>
            </div>
        </div>
    </footer>
);
